export const getBrowseEventsItems = ({ userMenuItemsLookup, showBrowseEvents }) => {
    const { browseEvents } = userMenuItemsLookup;

    if (showBrowseEvents) {
        return [browseEvents];
    }
    return [];
};
